import React, { useEffect, useRef } from "react";
import config from "../../config";
import LoadingCall from "../../js/LoadingCall";
import { useLogin } from "../../context/LoginContext";

function SignIn({ googleProfile, setGoogleProfile }) {
  const { sessionStatus } = useLogin();
  const CLIENT_ID = config.clientId;
  const GOOGLE_AUTH_URL = config.googleAuthUrl;
  const buttonRef = useRef(null);
  const CALLBACK_LOGIN_CODE_KEY = "login_code";

  const buildAuthUrl = () => {
    if (!GOOGLE_AUTH_URL) return "";
    try {
      const url = new URL(GOOGLE_AUTH_URL, window.location.origin);
      if (!url.searchParams.has("callbackUrl")) {
        const callbackUrl = window.location.href;
        url.searchParams.set("callbackUrl", callbackUrl);
      }
      return url.toString();
    } catch (error) {
      return GOOGLE_AUTH_URL;
    }
  };

  useEffect(() => {
    if (!GOOGLE_AUTH_URL) return;

    const params = new URLSearchParams(window.location.search);
    const loginCode = params.get(CALLBACK_LOGIN_CODE_KEY);
    if (!loginCode) return;

    setGoogleProfile({
      email: "",
      googleId: "",
      loginCode,
      idToken: "",
      err: 0,
      err_msg: "",
    });

    params.delete(CALLBACK_LOGIN_CODE_KEY);
    const nextQuery = params.toString();
    const nextUrl = `${window.location.pathname}${
      nextQuery ? `?${nextQuery}` : ""
    }`;
    window.history.replaceState({}, document.title, nextUrl);
  }, [GOOGLE_AUTH_URL, setGoogleProfile]);

  useEffect(() => {
    if (GOOGLE_AUTH_URL) return;
    let cancelled = false;

    const initGoogle = () => {
      if (cancelled) return;
      if (
        !window.google ||
        !window.google.accounts ||
        !window.google.accounts.id
      ) {
        setTimeout(initGoogle, 300);
        return;
      }

      window.google.accounts.id.initialize({
        client_id: CLIENT_ID,
        auto_select: true,
        callback: (response) => {
          setGoogleProfile({
            email: "",
            googleId: "",
            loginCode: "",
            idToken: response.credential || "",
            err: 0,
            err_msg: "",
          });
        },
      });

      if (
        buttonRef.current &&
        !googleProfile?.loginCode && !googleProfile?.idToken
      ) {
        window.google.accounts.id.renderButton(buttonRef.current, {
          theme: "outline",
          size: "large",
          width: 280,
        });
      }

      if (!googleProfile?.loginCode && !googleProfile?.idToken) {
        window.google.accounts.id.prompt();
      }
    };

    initGoogle();
    return () => {
      cancelled = true;
    };
  }, [CLIENT_ID, GOOGLE_AUTH_URL, setGoogleProfile, googleProfile?.loginCode, googleProfile?.idToken]);

  const isLoggedIn = Boolean(googleProfile?.loginCode || googleProfile?.idToken);

  return (
    <div
      id="btn-google-login"
      style={{
        display: "block",
        padding: "8px 16px",
        textAlign: "center",
      }}
    >
      {sessionStatus === "unauthenticated" && !isLoggedIn && (
        <>
          <div
            style={{
              marginTop: "25px",
              marginBottom: "20px",
              color: "#444",
              fontSize: "15px",
            }}
          >
            You are not signed in. Please sign in with Google to continue.
          </div>
          {GOOGLE_AUTH_URL ? (
            <button
              type="button"
              onClick={() => {
                const url = buildAuthUrl();
                if (url) {
                  LoadingCall.show();
                  window.location.href = url;
                }
              }}
              style={{
                border: "1px solid #dadce0",
                padding: "10px 16px",
                borderRadius: "4px",
                background: "#fff",
                color: "#3c4043",
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              Sign in with Google
            </button>
          ) : (
            <div ref={buttonRef}></div>
          )}
        </>
      )}
      <input
        id="is_loaded"
        name="is_loaded"
        type="hidden"
        value={isLoggedIn ? 1 : 0}
      />
    </div>
  );
}

export default SignIn;
